
    import './styles.scoped.css';
    export default {
  "modal-actions": "awsui_modal-actions_12hyz_1p88p_5",
  "submit-button": "awsui_submit-button_12hyz_1p88p_9"
};
  